import { render, staticRenderFns } from "./LevelsTable.vue?vue&type=template&id=417bc340&scoped=true&"
import script from "./LevelsTable.vue?vue&type=script&lang=js&"
export * from "./LevelsTable.vue?vue&type=script&lang=js&"
import style0 from "./LevelsTable.vue?vue&type=style&index=0&id=417bc340&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417bc340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
